export const Types = {
    ATTACH_NAV_BAR: "ATTACH_NAV_BAR",
    HOVER_NAV_BAR: "HOVER_NAV_BAR",
    SHOW_SNACK_MESSAGE: "SHOW_SNACK_MESSAGE",
    SHOW_DIALOG_MESSAGE: "SHOW_DIALOG_MESSAGE",
    SET_THEME_PALETTE: "SET_THEME_PALETTE",
    SET_THEME_DIRECTION: "SET_THEME_DIRECTION",
    SET_SNACK_MESSAGE: "SET_SNACK_MESSAGE",
};

export const attachNavBar = (payload) => ({
    type: Types.ATTACH_NAV_BAR,
    payload,
});

export const hoverNavBar = (payload) => ({
    type: Types.HOVER_NAV_BAR,
    payload,
});

export const showSnackMessage = (payload) => ({
    type: Types.SHOW_SNACK_MESSAGE,
    payload,
});

export const setSnackMessage = () => ({
    type: Types.SET_SNACK_MESSAGE,
});

export const showDialogMessage = (payload) => ({
    type: Types.SHOW_DIALOG_MESSAGE,
    payload,
});

export const setThemePalette = (payload) => ({
    type: Types.SET_THEME_PALETTE,
    payload,
});

export const setThemeDirection = (payload) => ({
    type: Types.SET_THEME_DIRECTION,
    payload,
});
